module.exports = __webpack_public_path__ + "static/img/img-6.60b7aeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-6.png
// module id = DQuo
// module chunks = 1